import { useParams } from "react-router-dom";
import { useApi } from "@/lib/api";
import { useSeo } from "@/lib/site";
import { Loading } from "@/components/site/Loading";
import { JourneyRunner } from "@/components/journey/JourneyRunner";
import PathwayPage from "./PathwayPage";

export default function JourneyRoute() {
  const { slug } = useParams();
  const { data, loading, error } = useApi(`/journeys/${slug}`);
  useSeo(data?.intro?.headline);
  if (loading) return <Loading />;
  if (error || !data) return <PathwayPage />;
  return <JourneyRunner key={slug} journey={data} />;
}
